import {combineReducers, configureStore} from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'
import {persistReducer, persistStore} from 'redux-persist'
import logger from 'redux-logger'

import tutorialVideo from './slices/tutorialVideo'
import dashboardBanner from './slices/dashboardBanner'
import walletConfig from './slices/walletConfig'
import termsCondition from './slices/termsCondition'
import partnerInfo from './slices/partnerInfo'

const persistConfig = {
  key: 'root',
  storage,
}

const rootReducer = combineReducers({
  tutorialVideo: tutorialVideo.reducer,
  dashboardBanner: dashboardBanner.reducer,
  walletConfig: walletConfig.reducer,
  termsCondition: termsCondition.reducer,
  partnerInfo: partnerInfo.reducer,
})

export default function createStore(initialState) {
  const persistedReducer = persistReducer(persistConfig, rootReducer)
  const middleware = []
  const storeConfig = {
    reducer: persistedReducer,
    middleware,
  }

  if (process.env.NODE_ENV === 'development') {
    middleware.push(logger)
  }

  if (initialState) {
    storeConfig.preloadedState = initialState
  }

  const store = configureStore(storeConfig)
  const persistor = persistStore(store)
  return {store, persistor}
}
